import React from "react";

import MainNav from "./main-nav";
import AuthNav from "./auth-nav";

const NavBar = () => {
  return (
    <div className="nav-container">
      
        <div className="container">
        <nav>
          <MainNav /> </nav>
          <AuthNav />
        </div>
     
    </div>
  );
};

export default NavBar;